export default   [
        {
            path: '/demo',
            // which is lazy-loaded when the route is visited.
            component: () => import( '@/views/demo/demos.vue'),
            meta: {
                title: '例子',
                requireAuth: true
            },
        },
    {
        path: '/demo/shuxuejisuan',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/demo/shuxuejisuan.vue'),
        meta: {
            title: '数学计算',
            requireAuth: true
        },
    },
        {
            path: '/demo/tables',
            // which is lazy-loaded when the route is visited.
            component: () => import( '@/views/demo/tables.vue'),
            meta: {
                title: '表格',
                requireAuth: true
            }
        },
        {
            path: '/demo/forms',
            // which is lazy-loaded when the route is visited.
            component: () => import( '@/views/demo/forms.vue'),
            meta: {
                title: '表单',
                requireAuth: true
            }
        },
    {
        path: '/demo/lyytest',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/demo/lyytest.vue'),
        meta: {
            title: 'lyy测试专用',
            isTabsPage: true,
            keepAlive:true
        }
    },
    ]
